import { render, staticRenderFns } from "./RightArea.vue?vue&type=template&id=20ce4190&"
import script from "./RightArea.vue?vue&type=script&lang=js&"
export * from "./RightArea.vue?vue&type=script&lang=js&"
import style0 from "./RightArea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports